import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "./context/ThemeContext";
import { HelmetProvider } from "react-helmet-async";

import { WagmiProvider } from 'wagmi';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { RainbowKitProvider, darkTheme, lightTheme } from '@rainbow-me/rainbowkit';
import { web3Config } from './config/web3';
import '@rainbow-me/rainbowkit/styles.css';

const queryClient = new QueryClient();

// ----------------------------------------------------
// 🌙 INITIALIZE THEME BEFORE REACT RENDERS (NO FLICKER)
// ----------------------------------------------------

const storedTheme = localStorage.getItem("theme");
const systemPrefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

// Apply theme early so UI doesn't flash in wrong theme
if (storedTheme === "dark" || (!storedTheme && systemPrefersDark)) {
  document.documentElement.classList.add("dark");
  localStorage.setItem("theme", "dark");
} else {
  document.documentElement.classList.remove("dark");
  localStorage.setItem("theme", "light");
}

// ----------------------------------------------------
// 🚀 RENDER APPLICATION
// ----------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <WagmiProvider config={web3Config}>
        <QueryClientProvider client={queryClient}>
          {/* We use RainbowKitProvider with dynamic theme depending on HTML class but for simplicity we wrap it normally */}
          <RainbowKitProvider theme={storedTheme === 'dark' ? darkTheme() : lightTheme()}>
            <ThemeProvider>   {/* ✅ Makes theme accessible globally */}
              <App />
            </ThemeProvider>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
